






























import { computed, defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useUserDelete from "@/hooks/useUserDelete";
import { formatDate } from "@/lib/time";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageAccountRestore",
  components: { BaseIcon, BaseButton, PageTitle, BasePage },
  setup(_, { root }) {
    const { authUser } = useAuthUser();
    const { restoreUser } = useUserDelete();
    const userRestoreTimeoutId = ref<ReturnType<typeof setTimeout> | null>(null);
    const loading = ref(false);
    const showWelcomeBack = ref(false);

    const restoreEndTime = computed(() => {
      return formatDate(new Date(authUser.value?.accountInfo.deleteAfter || ""), {
        month: "long",
        day: "2-digit",
        year: "numeric",
      });
    });

    const cleanTimeout = () => {
      userRestoreTimeoutId.value && clearTimeout(userRestoreTimeoutId.value);
      userRestoreTimeoutId.value = null;
    };

    const handleCancel = () => {
      root.$router.push({ name: "logout" });
    };

    const handleRestore = async () => {
      try {
        loading.value = true;
        await restoreUser();
        showWelcomeBack.value = true;
        userRestoreTimeoutId.value = setTimeout(() => {
          root.$router.replace(getProfileUrl(authUser.value ?? "")).then(() => location.reload());
        }, 5000);
      } finally {
        loading.value = false;
      }
    };

    const onClick = () => {
      cleanTimeout();
      root.$router.replace(getProfileUrl(authUser.value ?? "")).then(() => location.reload());
    };

    return {
      loading,
      restoreEndTime,
      showWelcomeBack,
      handleCancel,
      handleRestore,
      getProfileUrl,
      onClick,
    };
  },
});
